import React, { lazy } from 'react';
import { PrivateRoute } from '../../components/HasRights/HasRights';
import { Permissions } from '../../const/permissions';
import appRoutes from '@/configs/routes';
import getFeatureSourceKey from '../../domains/Featured/utils/getFeatureSourceKey';



const PageFeatures = lazy(() => import('../../domains/Featured/pages/PageFeatures'));
const PageFeatureCreate = lazy(() => import('../../domains/Featured/pages/PageFeatureCreate'));
const PageFeaturesEdit = lazy(() => import('../../domains/Featured/pages/PageFeaturesEdit'));
const PageFeatureDetails = lazy(() => import('../../domains/Featured/pages/PageFeatureDetails'));


export const featuresRoutes = ({ featureSource, urlPrefix = null }) => {
  const featureSourceKey = getFeatureSourceKey(featureSource);

  return [
    {
      path: appRoutes.urlPageFeatures({ featureSource, urlPrefix }),
      element: (
        <PrivateRoute allowedPermissions={[ Permissions.FEATURED.FEATURES[featureSourceKey].LIST ]}>
          <PageFeatures />
        </PrivateRoute>
      ),
    },
    {
      path: appRoutes.urlPageFeatureCreate({ featureSource, urlPrefix }),
      element: (
        <PrivateRoute allowedPermissions={[ Permissions.FEATURED.FEATURES[featureSourceKey].CREATE ]}>
          <PageFeatureCreate />
        </PrivateRoute>
      ),
    },
    {
      path: appRoutes.urlPageFeaturesEdit({ featureSource, urlPrefix }),
      element: (
        <PrivateRoute allowedPermissions={[ Permissions.FEATURED.FEATURES[featureSourceKey].EDIT ]}>
          <PageFeaturesEdit />
        </PrivateRoute>
      ),
    },
    {
      path: appRoutes.urlPageFeatureDetails({ featureSource, urlPrefix }),
      element: (
        <PrivateRoute allowedPermissions={[ Permissions.FEATURED.FEATURES[featureSourceKey].FIND ]}>
          <PageFeatureDetails />
        </PrivateRoute>
      ),
    },
  ];
};
